import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import StatBlock from '../_partials/StatBlock';
import s from './Status.scss';
export const StatusDetails = ({ deviation, deviation: { textContent } })=>{
    if (!textContent) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        className: s['details-block']
    }), /*#__PURE__*/ React.createElement(StatBlock, {
        deviation: deviation
    }));
};
StatusDetails.displayName = 'StatusDetails';
export default StatusDetails;

//# sourceMappingURL=Status.js.map